'use strict';

bbw.guest.SignInCtrl = ngtk.controller.Base.extend({

    $inject: ['$scope', 'bbw.AuthSvc', 'bbw.RedirectSvc', 'growl', 'enabledSocAuth'],

    _growl: undefined,
    _bbwAuthSvc: undefined,
    _bbwRedirectSvc: undefined,
    _enabledSocAuth: undefined,

    _init: function() {
        this.$scope.creds = {email: '', password: ''};
        this.$scope.providers = this._enabledSocAuth || ['vk', 'ok', 'facebook', 'twitter'];
    },

    authByPassword: function(use_intended_current_url) {
        if (angular.isUndefined(use_intended_current_url) && this.$scope.sameUrl) {
            use_intended_current_url = true;
        }
        var email = this.$scope.creds.email;
        var password = this.$scope.creds.password;
        var remember = !!this.$scope.creds.remember;
        if (!email || !password) {
            this._growl.warn('enter_creds');
            return;
        }
        this._bbwAuthSvc.authByPassword(email, password, remember, use_intended_current_url).catch(function(response) {
            this.$scope.creds.password = '';
            this._growl.error((angular.isObject(response) && response.error) || response || 'network_error');
            window.scrollTo(0, 0);
        }.bind(this));
    },

    oAuth: function(provider, use_intended_current_url) {
        if (angular.isUndefined(use_intended_current_url) && this.$scope.sameUrl) {
            use_intended_current_url = true;
        }
        if (provider) {
            this._bbwAuthSvc.oAuth(provider, use_intended_current_url).catch(function(response) {
                this._growl && this._growl.error(response.error);
            }.bind(this));
        }
    }

});
